module.exports = __webpack_public_path__ + "static/img/02bg.419b4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/02bg.png
// module id = c7pk
// module chunks = 1